// The shell-level read-only context (spec 15 §3.2 grace, D-495 ruling 2).
//
// While the tenant is suspended in grace, the office and floor shells wrap
// their screens in `ReadOnlyBoundary` with the sentence that explains why, and
// the shared `Button` refuses to SUBMIT a form inside it: it renders disabled,
// with that sentence as its title. The server refuses the write anyway
// (`403 TENANT_SUSPENDED_GRACE`); this saves the operator filling a form the
// server will turn down. Buttons that only navigate or open something are not
// submit buttons and keep working, and nothing outside a boundary (the sign-in
// card, the platform console) is touched.

import { createContext, useContext, type ReactNode } from "react";

/** Why writes are refused here, or null when they are not. */
const ReadOnlyContext = createContext<string | null>(null);

export function ReadOnlyBoundary({
  reason,
  children,
}: {
  /** The sentence a refused control carries; null lifts the boundary. */
  reason: string | null;
  children: ReactNode;
}) {
  return <ReadOnlyContext.Provider value={reason}>{children}</ReadOnlyContext.Provider>;
}

/** The read-only reason in force here, or null. */
export function useReadOnlyReason(): string | null {
  return useContext(ReadOnlyContext);
}
